<ng-container *ngIf="errors$ | async as errors">
    <wuc-input-alert
        *ngIf="errors.length"
        alertType="error"
        icon="cross-closed"
        [messages]="errors"
    />
</ng-container>
